import gql from 'graphql-tag';

export default gql`
  query indexPageTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          flightSearchForm {
            flightSearchFormTitle
          }
          emailSignUp {
            collapsedText
            titleText
            emailInputPlaceholder
            getDealsButtonLabel
            descriptionRegularText
            descriptionBoldText
            listItem1
            listItem2
            listItem3
            listItem4
            listItem5
            emailInvalidFormatError
            emailRequiredError
            emailAlreadyRegisteredError
            emailUnknownError
            emailSubscriptionSuccess
            selectHomeAirportInputPlaceholder
            selectHomeAirportFieldError
            resetPasswordAllwaysProfileTitle
            resetPasswordCTA
            resetPasswordCriteria
            resetPasswordLabel
            resetPasswordPlaceholder
            resetPasswordConfirmationLabel
            resetPasswordConfirmationPlaceholder
            passwordsTooShortValidationErrorMessage
            invalidPasswordValidationErrorMessage
            passwordsDoNotMatchValidationErrorMessage
            emailInputLabel
            selectHomeAirportInputLabel
            genericPasswordValidationErrorMessage
          }
          updatePassword {
            updatePasswordTitle
            securityErrorMessage
            newPasswordLabel
            reTypePasswordLabel
            updatePasswordCriteriaMessage
            updateButtonLabel
            recentlyUsedPasswordsErrorMessage
          }
          resetPassword {
            resetPasswordTitle
            newPasswordLabel
            reTypePasswordLabel
            updatePasswordCriteriaList
            updateButtonLabel
            passwordUpdatedMessage
            tokenExpiredMessage
            unknownErrorMessage
            accountCredentialSyncMessageHtml
          }
          upliftMerchandiseBanner {
            description
            ctaLabel
          }
          highlightedDeals {
            highlightedDealsText
          }
          paypalBanner {
            paypalInformationHtml
          }
          accountLockout {
            accountLockedScreenTitle
            accountLockedText
            okayButtonLabel
          }
        }
      }
    }
  }
`;
